<template>
  <Section :title="$t('tasks.file')" :border="true">
    <template #actions>
      <UploadFile :showText="false" @saveFiles="uploadTaskFile" :show-add-files="false" id="upload_task_file" :size="2" v-model="formData.files"  />
    </template>
    <FileUploaded  @remove="removeFile" :attach-files="formData.attachFiles" />
  </Section>
</template>
<script setup>
import FileUploaded from '@/components/FileUploaded.vue';
import UploadFile from '@/components/UploadFile.vue';
import { useSwal } from '@/composables/useSwal';
import { computed, nextTick, onMounted } from 'vue';
import {  ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Section from "@/Modules/Projects/components/Section.vue";
import Template from "@/Modules/Financial/views/Settings/ExpenseRecurrence/components/Template.vue";

const emits = defineEmits(['reset'])
const route = useRoute()
const store = useStore()
const {showSwal} = useSwal()

const secondaryColor = ref('rgba(240, 120, 23, 1)')

const formData = ref({
  task_id: route.params.id,
  files: [],
  attachFiles: [],
})

const files = computed(() => store.getters['files/getFiles'])

watch(() => files.value, (value) => {
 nextTick(() => {
  initFiles()
 })
},{deep: true})

const isUploading = ref(false)
const isDeleting = ref(false)


function removeFile(file){
  if(file.id){
    removeTaskFile(file.id)
  }
}

function uploadTaskFile(){
  isUploading.value = true
  let fileIds = files.value.map(item => item.id)
  let dataIds = formData.value.files.map(item => item.id)
  if(!(JSON.stringify(fileIds) === JSON.stringify(dataIds))){
    store.dispatch('files/uploadTaskFiles', formData.value)
      .then(res => {
        store.dispatch('files/loadTaskFiles', route.params.id)
      })
      .catch((err) => {

      }).finally(() => {
      formData.value.files = []
        isUploading.value = false
      }) 
  }else{
     isUploading.value = false
  }
}

const removeTaskFile = (id) => {
  showSwal(
      i18n.global.t('swal.file'),
      i18n.global.t('swal.file_text')
  ).then( async (result) => {
    if (result.value) {
      isDeleting.value = true

      store.dispatch('files/deleteTaskFile', id)
          .then(res => {
            store.dispatch('files/loadTaskFiles', route.params.id)
          })
          .catch((err) => {

          }).finally(() => {

              isDeleting.value = false
          })
          }
  });
}

const initFiles = () => {
  let data = []
  files.value?.map(fileData => {
    data.push({ name: fileData.filename, size: fileData.size || 0, url: fileData?.file_url, type: fileData?.extension ,id:fileData.id })
  })

  formData.value.attachFiles = data
}

onMounted(() => {
  nextTick(() => {
    initFiles()
  })
})

function getFileType(type){
  let mimeType = ''

  switch (type) {
    case 'pdf':
      mimeType = 'application/pdf';
      break;
    case 'doc':
      mimeType = 'application/msword';
      break;
    case 'docx':
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      break;
    case 'jpeg':
    case 'jpg':
      mimeType = 'image/jpeg';
      break;
    case 'png':
      mimeType = 'image/png';
      break;
    default:
      mimeType = '';
  }

  return mimeType;
}

</script>
<style>


.hover-effect {
  transition: background-color 0.3s ease;
}

.hover-effect:hover {
  background-color: #0072CE0D; /* Light red background */
}

.remove-btn {
  opacity: 0;
  transition: opacity 0.3s ease;
}

.hover-effect:hover .remove-btn {
  opacity: 1;
}

</style>